import { type UserConvoAIStreamingConfig } from '@atlassian/ai-agent-streaming';
import type { AiFeatureRequestEnvelopeConfluenceQuickSummaryRequest } from '@atlassian/convo-ai-api';

import type { SummaryLinkType } from '../QuickSummaryStreaming/QuickSummaryStreamingWrapper';

export type SummaryRequestBuilderType = {
	contentAri: string;
	enableFollowUp?: boolean;
	locale: string;
	summaryLinkType: SummaryLinkType;
};

export const buildSummaryRequest = ({
	contentAri,
	enableFollowUp = false,
	locale,
	summaryLinkType,
}: SummaryRequestBuilderType): [
	AiFeatureRequestEnvelopeConfluenceQuickSummaryRequest,
	UserConvoAIStreamingConfig,
] => {
	return [
		{
			ai_feature_input: {
				content_ari: contentAri,
				locale,
				summary_output_mimetype: 'text/markdown-plus',
				summary_link_type: summaryLinkType,
			},
		},
		{
			apiPath: 'v2/ai-feature/confluence-quick-summary',
			delayChunkUpdate: { gap: 10, time: 20 },
			enableFollowUp,
			headers: {
				'x-experience-id': 'page-summaries',
				'x-product': 'confluence',
			},
		},
	];
};
